import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';

const styles = (theme) => ({
  root: {
    border: '1px solid #38afd1',
    borderRadius: theme.shape.borderRadius,
    color: '#38afd1',
    backgroundColor: '#fff',
    fontSize: '12px',
    padding: '2px 4px 3px 4px',
  },
  paymentType: {
    border: '0px solid #e5ecf3',
    backgroundColor: '#e5ecf3',
    color: theme.palette.common.primary,
    fontWeight: theme.palette.common.boldFont,
  },

  error: {
    borderColor: theme.palette.common.error,
    color: theme.palette.common.error,
  },
  negative: {
    borderColor: theme.palette.common.negative,
    color: theme.palette.common.negative,
  },
  warning: {
    borderColor: theme.palette.common.warning,
    color: theme.palette.common.warning,
  },
  success: {
    borderColor: theme.palette.common.success,
    color: theme.palette.common.success,
  },
  default: {
    borderColor: '#38afd1',
    color: '#38afd1',
  },
  secondary: {
    borderColor: '#b3b3b3',
    color: '#b3b3b3',
  },
  chip: {
    margin: theme.spacing(1),
  },
});

const Tag = (props) => {
  const { classes, label, type } = props;
  return (
    <span className={classNames(classes.root, classes[type || 'default'])}>
      {label}
    </span>
  );
};

Tag.propTypes = {
  classes: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
  type: PropTypes.string,
};

export default withStyles(styles)(Tag);
